




























































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import PromotionService from '@/services/PromotionService';

const promotionService = new PromotionService();

@Component
export default class LoginDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public loading: boolean = false;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  async joinPromotion(promotionId: any) {
    try {
      this.loading = true;
      await promotionService.acceptPromotion({ promotionId });
      this.$store.commit('Snackbar/showNotification', { message: 'รับโปรโมชั่นสำเร็จ', error: false });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
    this.loading = false;
  }
}
